<template>
	<div class="panel">
		<div class="flex items-center justify-between pb-6">
			<div class="flex items-center space-x-2">
				<IconServices class="h-6 text-mx-gray-500 dark:text-mx-gray-400" />
				<span class="mt-1 text-sm uppercase text-mx-gray-500 dark:text-mx-gray-400">
					{{ t('dashboard-services.title') }}
				</span>
			</div>
			<LinkButton
				to="/services"
				:text="t('dashboard-services.upgrade-services')"
			/>
		</div>
		<div class="-mx-6 text-sm lg:-mx-8 border-y-2 bg-mx-gray-100 dark:border-y-mx-green-900 dark:bg-mx-green-800">
			<div class="flex items-center justify-between px-8 py-4">
				<span>
					{{ packageText }}
				</span>
				<span>
					{{ packagePrice }}
				</span>
			</div>
			<div class="flex items-center justify-between px-8 py-4 border-t-2 dark:border-t-mx-green-900">
				<div>
					<span>
						{{ t('dashboard-services.voip-telephone') }}
					</span>
					<span class="text-mx-gray-500 dark:text-mx-gray-400">
						{{ ` (QTY: ${voipNumbersCount || 0})` }}
					</span>
				</div>
				<span>
					{{ voipPrice }}
				</span>
			</div>
			<div class="flex items-center justify-between px-8 py-4 border-t-2 dark:border-t-mx-green-900">
				<div>
					<span>
						{{ t('dashboard-services.static-ip') }}
					</span>
					<span class="text-mx-gray-500 dark:text-mx-gray-400">
						{{ ` (QTY: ${staticIpsCount || 0})` }}
					</span>
				</div>
				<span>
					{{ staticIpPrice }}
				</span>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { PortalAccountServices } from '@/types/auth'
import { getTieredStaticIpPrice, getVoipPrice } from '@/utils/getPrice'
import { useI18n } from 'vue-i18n'

const { t } = useI18n({ useScope: 'global' })

const props = defineProps({
	accountServices: {
		type: Object as PropType<PortalAccountServices>,
		required: true
	},
	voipNumbersCount: {
		type: Number,
		default: 0
	},
	staticIpsCount: {
		type: Number,
		default: 0
	}
})

const {
	accountServices, voipNumbersCount, staticIpsCount
} = toRefs(props)

const packageText = computed(() => {
	return `${accountServices.value.packageSpeed} MBPS Internet`
})

const packagePrice = computed(() => {
	return `$${accountServices.value.packagePrice} /mo`
})

const voipPrice = computed(() => {
	return voipNumbersCount.value
		? `$${getVoipPrice(voipNumbersCount.value)} /mo`
		: `${t('dashboard-services.add-voip')} $${getVoipPrice(1)} /mo`
})

const staticIpPrice = computed(() => {
	return staticIpsCount.value
		? `$${getTieredStaticIpPrice(staticIpsCount.value)} /mo`
		: `${t('dashboard-services.add-static-ip')} $${getTieredStaticIpPrice(1)} /mo`
})
</script>
